import React from "react";
import axios from 'axios';
import '../auth.css';
import '../list.css';
import { Link } from 'react-router-dom';
import {reactLocalStorage} from 'reactjs-localstorage';
import i18n from '../i18n';
import {connect} from 'react-redux';
import Menutest from './menu.js';
import { Grid, Segment} from 'semantic-ui-react';
import ReactTooltip from 'react-tooltip'
import { List ,Image} from 'semantic-ui-react'
import { SemanticToastContainer, toast } from 'react-semantic-toasts';
import 'react-semantic-toasts/styles/react-semantic-alert.css';
import { API_BASE_URL } from "../utils/endpoints";

class Promotion extends React.Component {

    state = {
        persons: [],
        isArabic:false,
        id:''
      
      };
      componentDidMount() {
        var lang=i18n.language;
        if(lang ==="ar")
        {
          this.setState({isArabic:true})
        /*  document.querySelector('.blues_color').style = 'text-align:right;width: 20%;margin-right: 25%;white-space: pre;';       
          document.querySelector('.add_btn_snder').style = 'float:left;width:4.5%'; 
          document.querySelector('.container_cards').style = 'margin-top: 2%;width:95% !important';
         */ 
        }
       
        var token=reactLocalStorage.get('accessToken');
        var ip=API_BASE_URL;
        var s2 = "localhost:3000";
        var apiBaseUrl;
        if(ip.includes(s2))
        {
         apiBaseUrl =API_BASE_URL + "/core/user/rest/advertisments/getAllAdv";
        }
        else
        {
         apiBaseUrl = API_BASE_URL+"/core/user/rest/advertisments/getAllAdv";
        }
        var headers = {'Content-Type': 'application/json', 'token' :token }
        axios.get(apiBaseUrl,{headers: headers})
            .then(res => {
              const persons = res.data.result.advertisments;
              if(persons != undefined)
              {
                this.setState({ persons });
   
              }
              
            })
   }
 
            
            Deleteform=event=>{
                event.preventDefault();
                var token=reactLocalStorage.get('accessToken');
              
              
                this.setState({ id: event.target.id });
                var data="";
                var id_user= event.target.id;
              
                var apiBaseUrl 
                var ip=API_BASE_URL;
                var s2 = "localhost:3000";
               var body={
                id_user:id_user
               }
                var apiBaseUrl;
                if(ip.includes(s2))
                {
                 apiBaseUrl =API_BASE_URL + "/core/user/rest/senderid/deleteSenderId/"+id_user;   
                }
                else
                {
                 apiBaseUrl = API_BASE_URL+"/core/user/rest/senderid/deleteSenderId/"+id_user;
                }
                var headers = {
                 'Content-Type': 'application/json',
                  'token' :token
                  }
                axios.post(apiBaseUrl,{},{headers: headers}).then(function (response)
                {
              
                if(response.status === 200)
                {
                   
                   toast({
                    type: 'success',
                    title: 'Warning',
                    description: "deleted Successfully",
                    animation: 'bounce',
                    time: 5000,
                   
                });
                window.location="Promotion";
              
              
                }
                else if(response.status === 204){
                console.log("Something wrong");
              
                }
                else{
                console.log("Something wrong");
              
              
                }
                })
                .catch(function (error) {
                console.log(error);
                });
            }
Editform=(event,sender_id,id,image)=>{
    this.setState({ id: event });
    reactLocalStorage.set('id_user_edit_promotion',event);
    reactLocalStorage.set('id_user_edit_promotion_description',sender_id);
    reactLocalStorage.set('id_user_edit_promotion_type',id);
    reactLocalStorage.set('id_user_edit_image',image);
    window.location="EditPromotion";
}
    render(){
        return(
            <div className="big_div">
            <Menutest/>
       <div className="actionMenu">
       <Grid columns={2} divided>
     <Grid.Row stretched>


       <Grid.Column className="grid_logo">
         <Segment>
         <h3 className="text_style dark_green_color">{i18n.t('Promotion.label')}</h3>
         </Segment>
       </Grid.Column>

       <Grid.Column className="grid_language">
         <Segment>
         <Grid.Column className="grid_language" style={{width:'86%'}}>
            <Segment>
            <Link to="/app/AddPromotion"> 
               <img src={require('../pictures/plus_green.png')} className="Logo_auth" alt="logo" data-tip={i18n.t('add.label')}/>
            </Link>
            <ReactTooltip />
            
            </Segment>
          
          </Grid.Column>
   
     
      
       
     

         </Segment>
       </Grid.Column>



     </Grid.Row>
   </Grid>


            
   <hr/>
   <div className="container_cards view_basic">
      { this.state.persons.map(person =>
      <List divided relaxed>
    <List.Item>
    <List.Content floated={this.state.isArabic ?'left' : 'right' }>
              <Image avatar className="edit_btn_sub_sender edit_test edit_sub add_btn_snder" data-tip={i18n.t('edit.label')} style={{display: this.state.show ? 'none' : 'block' }} src={require('../pictures/pencil_black.png')}  id={person.id} name={person.sender_id} value={person.isAdv} onClick={this.Editform.bind(this,person.id,person.sender_id,person.adv)}/>
              </List.Content>
              <ReactTooltip />
              <List.Content floated={this.state.isArabic ?'left' : 'right' } >
              <Image avatar className="delete_btn_sub_sender add_btn_snder" data-tip={i18n.t('delete.label')} style={{display: this.state.show ? 'none' : 'block' }} src={require('../pictures/cancel-button_black.png')} id={person.id} onClick={this.Deleteform}/>
      </List.Content>
      <ReactTooltip />
      
      <List.Content>
        <List.Header as='a' id={person.id} style={{float:this.state.isArabic? 'right':'',marginRight:this.state.isArabic? '2%':''}}>{i18n.t('Name.label')}  : {person.advertisment_title}</List.Header>
      </List.Content>


    </List.Item>


    <br/>
  </List>

)}

      </div>

   </div></div>
        );
    }
}
const mapStateToProps = (state)=>{
    return {...state}
  }
  export default connect(mapStateToProps) (Promotion);